const useCurrency = () => {
    return (value: number): string => `$${value}`
}

export default useCurrency
